<script lang="ts" setup>
import { PropType } from 'vue';
import { ExpenseLine } from '@/models/expense';
import { formatCurrency } from '@/filters/filters';

const { line } = defineProps({
  line: {
    type: Object as PropType<ExpenseLine>,
    required: true,
  },
});
</script>
<template>
  <tr class="expense-detail">
    <td>{{ line.description }}</td>
    <td>
      <div class="expense-currency">
        <span>{{ formatCurrency(line.amount, true) }}</span>
      </div>
    </td>
    <td>
      <div class="expense-currency">
        <div class="vat-percentage">{{ line.vat }}%</div>
        <span>{{ formatCurrency(line.vat_amount) }}</span>
      </div>
    </td>
    <td>
      <div class="expense-currency">
        <span>{{ formatCurrency(line.total) }}</span>
      </div>
    </td>
  </tr>
</template>
